import { render } from "./PurchaseHistory.vue?vue&type=template&id=9c058414"
import script from "./PurchaseHistory.vue?vue&type=script&lang=js"
export * from "./PurchaseHistory.vue?vue&type=script&lang=js"
script.render = render

export default script